import {useMemo, memo} from 'react';
import {getIn} from 'formik';
import {translate} from '../../utils';
import {useAddGuestsStatic} from './AddGuestsContext';
import {mapToOptions} from './addGuestsUtilities';
import {AddGuestsTableGuestEntry} from './AddGuestsTableGuestEntry';

export const AddGuestsTableRowWithGuest = memo(function AddGuestsTableRowWithGuest({
    roomMaxOccupancy,
    roomName,
    roomCategoryName,
    guestsCountInRoom,
    roomIndex,
    guest,
    guestIndex,
    errors,
    setErrors,
    regionMaps,
    onRegionMapsUpdate,
    setFieldValue,
    onAddGuest,
    onRemoveGuest,
    onSelectClientSuggestion,
}) {
    const {guestColumnKeys, clientTitlesMap, countriesMap, languageMap, vipStatusMap, maxGuestsPerRoom} = useAddGuestsStatic();

    const titleOptions = useMemo(() => mapToOptions(clientTitlesMap), [clientTitlesMap]);
    const countryOptions = useMemo(() => mapToOptions(countriesMap), [countriesMap]);
    const languageOptions = useMemo(() => mapToOptions(languageMap), [languageMap]);
    const vipOptions = useMemo(() => mapToOptions(vipStatusMap), [vipStatusMap]);
    const nationalityOptions = useMemo(() => mapToOptions(countriesMap), [countriesMap]);

    const isOverOccupancy = guestIndex >= roomMaxOccupancy;
    const roomNameAndCategory = `${roomName} | ${roomCategoryName}`;
    const addGuestButtonIndex = roomMaxOccupancy <= 1 || guestsCountInRoom <= 2 ? 1 : Math.min(roomMaxOccupancy, guestsCountInRoom) - 1;
    const isGuestRowEmpty = guestColumnKeys.every(key => guest[key] === undefined || guest[key] === null || guest[key] === '');
    const guestErrors = getIn(errors, `rooms.${roomIndex}.guests.${guestIndex}`);

    return (
        <tr className={([isOverOccupancy && 'danger', isGuestRowEmpty && 'row-muted'].filter(Boolean).join(' '))} >
            {guestIndex === 0 && (
                <td className="skip-muted" data-column-key="roomKeyAndCategory">
                    <div
                        className="truncate text-bold"
                        title={roomNameAndCategory}
                    >
                        {roomNameAndCategory}
                    </div>
                </td>
            )}

            {guestIndex >= 1 && guestIndex < addGuestButtonIndex && (
                <td className="skip-muted" data-column-key="addGuest" />
            )}

            {guestIndex === addGuestButtonIndex && (
                <td
                    rowSpan={guestsCountInRoom - addGuestButtonIndex}
                    className="vertical-align-top text-right skip-muted"
                    data-column-key="addGuest"
                >
                    <button
                        type="button"
                        className="btn btn-default btn-sm"
                        title={translate('frontend', 'ADD_GUESTS_ADD_GUEST')}
                        disabled={guestsCountInRoom === maxGuestsPerRoom}
                        onClick={onAddGuest}
                    >
                        <i className="fa fa-user-plus" />
                    </button>
                </td>
            )}

            <AddGuestsTableGuestEntry
                roomIndex={roomIndex}
                guestIndex={guestIndex}
                guest={guest}
                guestErrors={guestErrors}
                titleOptions={titleOptions}
                countryOptions={countryOptions}
                languageOptions={languageOptions}
                vipOptions={vipOptions}
                nationalityOptions={nationalityOptions}
                regionMaps={regionMaps}
                onRegionMapsUpdate={onRegionMapsUpdate}
                errors={errors}
                setErrors={setErrors}
                setFieldValue={setFieldValue}
                onRemoveGuest={onRemoveGuest}
                onSelectClientSuggestion={onSelectClientSuggestion}
            />
        </tr>
    );
});
